import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { authClient } from "@/utils/auth-client";

export function useSendVerificationOtp() {
  return useMutation({
    mutationFn: async ({ email, type }: { email: string; type: "sign-in" }) => {
      const { data, error } = await authClient.emailOtp.sendVerificationOtp({
        email,
        type,
      });

      if (error) {
        throw new Error(error.message || "Failed to send OTP");
      }

      return data;
    },
    onError: (error) => {
      toast.error(error.message || "Failed to send OTP. Please try again.");
    },
    onSuccess: () => {
      toast.success("OTP sent successfully!");
    },
  });
}

export function useEmailOtpSignIn() {
  return useMutation({
    mutationFn: async ({ email, otp }: { email: string; otp: string }) => {
      const { data, error } = await authClient.signIn.emailOtp({
        email,
        otp,
      });

      if (error) {
        throw new Error(error.message || "Failed to sign in");
      }

      return data;
    },
    onError: (error) => {
      toast.error(error.message || "Failed to Login. Please try again.");
    },
  });
}
